import React from 'react';
import './FormGroup.css';

const FormGroup = ({ label, helpText, error, required, children, className = '' }) => {
  return (
    <div className={`p-form-group ${error ? 'p-form-group--error' : ''} ${className}`}>
      {label && (
        <label className="p-form-group__label">
          {label}
          {required && <span className="p-form-group__required"> *</span>}
        </label>
      )}
      {helpText && !error && (
        <span className="p-form-group__help">{helpText}</span>
      )}
      {children}
      {error && (
        <span className="p-form-group__error">{error}</span>
      )}
    </div>
  );
};

export default FormGroup;
